import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface Bookmark{
  id: number,
  word: string,
  create_date: string,
  Exam:{
    id: number,
    name: string
  }
}

export interface BookmarkRequest{
  word: string,
  // exam_id: number
}

export const bookmarkApi = createApi({
  reducerPath: 'bookmarkApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['bookmark'],

  endpoints: (builder) => ({
    getUserBookmarks: builder.query<Bookmark[],void>({
      query: () => 'bookmark/userAll',
      providesTags: ['bookmark']
    }),
    deleteBookmark: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `bookmark/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['bookmark']
    }),
    saveBookmark: builder.mutation<boolean, BookmarkRequest>({
      query: (data) => ({
        url: 'bookmark',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['bookmark']
    }),

    translate: builder.query<any, string>({
      query: (word) => `dictionary/${word}`,
    }),
  }),
})

export const { useGetUserBookmarksQuery , useDeleteBookmarkMutation, useTranslateQuery, useSaveBookmarkMutation } = bookmarkApi
